import { useState } from "react";
import { ArrowRight } from "lucide-react";
import FadeIn from "./FadeIn";
import LeadForm from "./LeadForm";
import { useLang } from "../../contexts/LanguageContext";

export default function CTABand({ content }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <section
      id="contact"
      className="bg-[#1b1c1e] text-white py-24 md:py-32"
      data-testid="cta-band"
    >
      <div className="container-x">
        <FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
            <div className="md:col-span-7">
              <div className="eyebrow text-white/60 mb-8">{t(content?.cta?.eyebrow)}</div>
              <h2 className="font-display font-bold text-white text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-[-0.02em] max-w-[18ch]">
                {t(content?.cta?.headline)}
              </h2>
              {t(content?.cta?.supporting) && (
                <p className="mt-6 text-white/70 text-base md:text-lg max-w-[52ch] leading-relaxed">
                  {t(content?.cta?.supporting)}
                </p>
              )}
              <button
                type="button"
                onClick={() => setOpen(true)}
                className="mt-10 inline-flex items-center gap-3 bg-white text-[#16181c] px-7 py-4 font-medium hover:bg-[#f3f3f0] transition-colors"
                data-testid="cta-button"
              >
                {t(content?.cta?.button_text)} <ArrowRight size={16} />
              </button>
            </div>
            <div className="md:col-span-5 md:pl-10 grid grid-cols-1 gap-6 text-[15px]">
              <ContactRow label="Office" value={t(content?.cta?.office)} />
              <ContactRow label="Email" value={content?.cta?.email} href={content?.cta?.email ? `mailto:${content.cta.email}` : null} />
              <ContactRow label="Phone" value={content?.cta?.phone} href={content?.cta?.phone ? `tel:${(content.cta.phone || "").replace(/\s/g, "")}` : null} />
              {content?.cta?.whatsapp && (
                <ContactRow
                  label="WhatsApp"
                  value={content.cta.whatsapp}
                  href={`https://wa.me/${(content.cta.whatsapp || "").replace(/[^\d]/g, "")}`}
                  external
                />
              )}
              {content?.cta?.linkedin && (
                <ContactRow
                  label="LinkedIn"
                  value={content.cta.linkedin.replace(/^https?:\/\//, "")}
                  href={content.cta.linkedin}
                  external
                />
              )}
            </div>
          </div>
        </FadeIn>
      </div>

      <LeadForm open={open} onClose={() => setOpen(false)} content={content} />
    </section>
  );
}

function ContactRow({ label, value, href, external }) {
  if (!value) return null;
  return (
    <div className="border-t border-white/20 pt-6">
      <div className="eyebrow text-white/50 mb-2">{label}</div>
      {href ? (
        <a
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noreferrer noopener" : undefined}
          className="text-white hover:text-white/80 break-words"
        >
          {value}
        </a>
      ) : (
        <div className="text-white break-words">{value}</div>
      )}
    </div>
  );
}
